import { Context, CustomQuery } from '@vue-storefront/core';
import { OrderItem, POrder, ApiResult, PreOrder } from '../../types';
//
export default async function orderPreview(context: Context, params: CustomQuery): Promise<ApiResult> {
  const url = new URL('/mall/order/preorder', context.config.api.url);
  const { data: res } = await context.client.post(url.href, params);
  if (res.code === 0) {
    const pdata = res.data.order ? res.data.order : res.data.combine_order;
    const errs = res.data?.errs || [''];
    const keys = Object.keys(pdata.orders);
    if (errs && errs.length > 0 && res.data?.not_matched_out_id) {
      errs.forEach((x, index) => {
        if (x) {
          if (keys && keys.length) {
            for (const key of keys) {
              const item = pdata.orders[key].order_item.find((item) => item.out_id == res.data?.not_matched_out_id);
              if (item.title) {
                x.title = item.title + ' ' + item.sku_prop;
              }
            }
          }
        }
      });
    }
    const preOrder: PreOrder = {
      prepayId: pdata.prepay_id,
      totalCount: pdata.total_count,
      payment: pdata.payment,
      orders: [],
      errs: errs,
      expressChart: null,
      promoCodes: pdata.promo_codes,
      previewId: pdata.preview_id,
      hasIdentityCheck: pdata.has_identity_check,
      goodsService: pdata.goods_services,
      transCurrency: pdata.trans_currency
    };
    for (const key of keys) {
      const orderDetail: POrder = {
        // Id: pdata.orders[key].id,
        orderId: pdata.orders[key].order_id,
        memberId: pdata.orders[key].member_id,
        totalCount: pdata.orders[key].total_count,
        discount: pdata.orders[key].discount,
        postFee: pdata.orders[key].post_fee,
        taxFee: pdata.orders[key].tax_fee,
        payment: pdata.orders[key].payment,
        // payment: pdata.orders[key].current_currency_amount,
        activityInfo: pdata.orders[key].activity_info,
        userNote: pdata.orders[key].user_note,
        memberNote: pdata.orders[key].member_note,
        fromId: pdata.orders[key].from_id,
        fxId: pdata.orders[key].fx_id,
        payWayId: pdata.orders[key].pay_way_id,
        status: pdata.orders[key].status,
        pickupOrder: pdata.orders[key].pickup_order,
        shopId: pdata.orders[key].shop_id,
        addressId: pdata.orders[key].address_id,
        createTime: '',
        orderItem: [],
        combined: pdata.orders[key].combined,
        shop: {
          shopId: pdata.orders[key].shop.shop_id,
          userId: pdata.orders[key].shop.user_id,
          title: pdata.orders[key].shop.title,
          logo: pdata.orders[key].shop.logo,
          address: pdata.orders[key].shop.address,
          createTime: pdata.orders[key].shop.create_time,
          updateTime: pdata.orders[key].shop.update_time
        },
        express: {
          carryId: pdata.orders[key]?.express?.carry_id,
          expressName: pdata.orders[key]?.express?.name,
          postage: pdata.orders[key]?.express?.postage
        },
        idName: pdata.orders[key].id_name,
        idNumber: pdata.orders[key].id_number,
        idType: pdata.orders[key].id_type,
        country: pdata.orders[key].country,
        state: pdata.orders[key].state,
        city: pdata.orders[key].city,
        street: pdata.orders[key].street,
        apartment: pdata.orders[key].apartment,
        zipCode: pdata.orders[key].zip_code,
        phone: pdata.orders[key].phone,
        lastName: pdata.orders[key].last_name,
        firstName: pdata.orders[key].first_name,
        postFeeTax: pdata.orders[key].post_fee_tax,
        insuranceFee: pdata.orders[key].insurance_fee,
        insuranceTax: pdata.orders[key].insurance_tax
      };
      if (pdata.orders[key] && pdata.orders[key].order_item) {
        // 循环list
        pdata.orders[key].order_item.forEach((x) => {
          const item: OrderItem = {
            // Id: x.Id,
            orderId: x.order_id,
            shopId: x.shop_id,
            goodId: x.good_id,
            skuId: x.sku_id,
            num: x.num,
            price: x.price,
            // price: x.current_currency_price,
            discount: x.discount,
            totalPayment: x.total_payment,
            // totalPayment: x.current_currency_amount,
            activityInfo: x.activity_info,
            title: x.title,
            imgUrl: x.img_url,
            skuProp: x.sku_prop,
            isGift: x.is_gift,
            taxFee: x.tax_fee
          };
          orderDetail.orderItem.push(item);
        });
      }
      preOrder.orders.push(orderDetail);
    }
    if (pdata.expresses) {
      const expKeys = Object.keys(pdata.expresses);
      preOrder.expressChart = {};
      for (const key of expKeys) {
        preOrder.expressChart[key] = [];
        pdata.expresses[key].map(express => {
          preOrder.expressChart[key].push({
            expressName: express.name,
            postage: express.postage,
            carryId: express.carry_id
          });
        });
      }
    }

    // //console.log('res.express', JSON.stringify(res.data.order.expresses))

    // if (pdata.orders[key] && pdata.orders[key].sub_order) {
    //     // 循环list
    //     pdata.orders[key].sub_order.forEach((x) => {
    //         const subOrder: SubOrder = {
    //             subOrderId: x.sub_order_id,
    //             payment: x.payment,
    //         };
    //         orderDetail.subOrder.push(subOrder);
    //     });
    // }
    // //console.log('preOrder-------------', preOrder);
    res.data = preOrder;
  }

  return res;
}
